module.exports = __webpack_public_path__ + "static/web-app-element-2-914a57ee4478c9d46931e77bf078643a.png";